import { LicenseIcon } from '@hugeicons/react'

export const Header = ({ id = '', step, challenge }) => {
  const hasDescription = !!challenge?.description

  return (
    <div
      id={`level-play-header${id}`}
      className="w-full shrink-0 grow-0 px-4 pt-4 pb-2"
    >
      <div className="mx-auto flex w-full max-w-[550px] flex-col items-start gap-2">
        {step.isIntro && (
          <div className="flex items-end gap-1 -mb-1">
            <LicenseIcon className="text-info" size={14} variant="duotone" />
            <span className="uppercase font-bold text-info text-xs block leading-none">
              Introdução
            </span>
          </div>
        )}
        <span className="text-left block text-2xl font-bold mb-0">
          {challenge?.name}
        </span>
        {hasDescription && (
          <span className="font-bold text-gray-700 text-sm text-left block">
            {challenge?.description}
          </span>
        )}
      </div>
    </div>
  )
}
